/**
 * DemoTopBar — shared top bar used on every /demos* surface.
 *
 * Uses the SAME brand lockup as the public `<Header />` component
 * (LIFE_LOGO + divider + NexWordmark) so the demo surfaces feel
 * continuous with the marketing site.  Only the "Home" button on the
 * right is new — it jumps the visitor back to `/`.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { LIFE_LOGO } from "@/lib/assets";
import NexWordmark from "@/components/NexWordmark";

export default function DemoTopBar() {
  return (
    <div
      data-testid="demo-top-bar"
      className="w-full border-b border-white/10 bg-[#0B0F19]/90 backdrop-blur-xl sticky top-0 z-30"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4 px-6 md:px-10 py-3">
        <Link
          to="/"
          data-testid="demo-top-bar-home"
          className="flex items-center gap-4 shrink-0"
          title="Back to Nexengines home"
        >
          <img
            src={LIFE_LOGO}
            alt="Learning Institute For Empowerment"
            className="h-10 w-10 object-contain"
          />
          <div className="hidden sm:flex items-center gap-4">
            <div className="w-px h-8 bg-nex-border" />
            <NexWordmark size="text-xl" />
          </div>
        </Link>
        <Link
          to="/"
          data-testid="demo-top-bar-home-btn"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 hover:bg-nex-gold/10 text-nex-chrome hover:text-nex-gold border border-white/10 hover:border-nex-gold/60 font-mono text-[11px] tracking-[0.14em] uppercase transition"
        >
          <Home className="w-3.5 h-3.5" /> Home
        </Link>
      </div>
    </div>
  );
}
